import React, { useEffect, useState } from 'react'
import '../../assets/home/category-product.css'
import { Link } from 'react-router-dom';

function CategoryProduct(props) {
  const produits = props.produits;
  let [prods, setProds] = useState([]);
  const [limite] = useState(4); 
  

  useEffect(()=>{
    showAll();
  },[])

  const showAll = ()=>{
    let p =[];

      for (let i = 0; i < limite; i++) {
        if (produits[i]) {
          p.push(produits[i]);
        }
        
      }
    setProds(p)
  }
  

  return (
    <div className='container category-product' id='catHome'>
        <div className="cat-header">
            <h4 className='cat-subtitle'>DÉCOUVREZ NOS</h4>
            <h3 className='cat-title'>{props.catTitle}</h3>
            <button > <Link className='lien' to={"/categories/"+props.idCat}>Tout voir <img src={window.location.origin +"/images/fleche_green.svg"} alt="" /></Link></button>
        </div>
        <div className="cat-body">
          {
            prods.map(prod => <div className="cat-item" key={prod.id}>
                          <Link className='item-title' to={{
                            pathname: "/produit/"+prod.id
                          }}><img src={prod.image} alt="" /></Link>
                          <h3><Link className='item-title' to={{
                            pathname: "/produit/"+prod.id
                          }}>{prod.nom}</Link></h3>
                          <p className='item-price'>{prod.prix} </p>
                          <p className='item-note'>
                            <span> {prod.note}</span> <span><img src={window.location.origin +"/images/start.png"} alt="" /></span><span className='avis'> {prod.avis} avis</span>
                            </p>
                      </div>)
          }
            
        </div>
    </div>
  )
}

export default CategoryProduct